import React from 'react';
import { Text } from 'react-native';
import { fontFamily } from '../../helpers/fontFamily';
import { useScreenWidth } from './use-mobile';

const InventoryTableDataText = ({ data, isMobile, doubleWidth, toLeft, isHeader}) => {
  const screenWidth = useScreenWidth();
  const isSmallMobile = screenWidth < 480;

  return (
    <Text style={textStyles(isMobile, screenWidth, doubleWidth, toLeft, isHeader, isSmallMobile).textData}>
      {data}
    </Text>
  );
};

const textStyles = (isMobile, screenWidth, doubleWidth, toLeft, isHeader, isSmallMobile) => {
  const getColumnWidth = () => {
    if (isSmallMobile) {
      return screenWidth / 6
    } else if (isMobile) {
      return screenWidth / 5;
    } else {
      return 96.5;
    }
  };

  const singleWidth = getColumnWidth();
  const finalWidth = doubleWidth ? singleWidth * 2 : singleWidth;
  const getFontSize = () => {
    if (isSmallMobile) return 10;
    if (isMobile) return 12;
    if (isHeader) return 14;
    return 16;
  };

  return {
    textData: {
      color: '#ffffff',
      fontSize: getFontSize(),
      fontFamily: isHeader ? fontFamily.font600 : fontFamily.font400,
      textAlign: toLeft ? 'left' : 'center',
      width: finalWidth,
      minWidth: finalWidth,
      marginLeft: doubleWidth && '1%',
      flexShrink: 0,
      paddingHorizontal: isSmallMobile ? 2 : isMobile ? 4 : 6,
      lineHeight: isSmallMobile ? 14 : isMobile ? 16 : 18,
    },
  };
};

export default InventoryTableDataText;
